export default from './BuyersChatList';



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyersChatList/index.js